<template>
  <modal
    class="createAssetGroup"
    name="editAsset"
    transition="pop-out"
    :width="800"
    :height="600"
    @opened="opened"
    @closed="closed"
  >
    <div class="text-center assets_modal_div branch_assets_modal">
      <img
        src="@/assets/img/cancel-button.svg"
        class="close_assets_modal"
        @click="closeModal"
      />
      <p class="asset_modal_title">{{ $t("text.editAsset.editAsset") }}</p>
      <form>
        <input type="file" id="fileInput" name="Logo" style="display: none" />
        <div class="modal_form_field bas">
          <label class="assets_label required">{{
            $t("text.editAsset.assetName")
          }}</label>
          <input type="text" class="modal_input" v-model="assetDetails.name" />
        </div>
        <div class="modal_form_field bas">
          <label class="assets_label">{{
            $t("text.editAsset.assetDescription")
          }}</label>
          <input
            type="text"
            class="modal_input"
            v-model="assetDetails.description"
          />
        </div>
        <div class="modal_form_field bas">
          <label class="assets_label">{{
            $t("text.editAsset.assetGroup")
          }}</label>
          <select
            class="modal_input"
            v-model="assetDetails.assetGroupId"
            @change="getGroup"
          >
            <option value="selectGroup" disabled>
              {{ $t("text.assets.selectGroup") }}
            </option>
            <option
              v-for="(group, index) in groups"
              :key="index"
              :value="group.id"
            >
              {{ group.name }}
            </option>
          </select>
        </div>
        <div class="modal_form_field bas" v-if="assetstatus === 0">
          <label class="assets_label">{{
            $t("text.assets.assetLicenseNo")
          }}</label>
          <input
            type="text"
            class="modal_input"
            v-model="assetDetails.assetLicenseNo"
          />
        </div>
        <div class="modal_form_check bas">
          <label>{{ $t("text.assets.isServicable") }}</label>
          <div class="modal_form_checkbox">
            <input type="checkbox" v-model="assetDetails.isServiceable" />
            <div
              class="dark_check"
              :class="!assetDetails.isServiceable ? 'light_check' : null"
              @click="toggleCheck"
            >
              <div
                class="dark_check_inner"
                :style="[assetDetails.isServiceable ? { left: '38px' } : null]"
              ></div>
            </div>
          </div>
        </div>
        <div class="modal_form_check bas">
          <label>{{ $t("text.assets.isRenewable") }}</label>
          <div class="modal_form_checkbox">
            <input type="checkbox" v-model="assetDetails.isRenewable" />
            <div
              class="dark_check"
              :class="!assetDetails.isRenewable ? 'light_check' : null"
              @click="toggleRenewalCheck"
            >
              <div
                class="dark_check_inner"
                :style="[assetDetails.isRenewable ? { left: '38px' } : null]"
              ></div>
            </div>
          </div>
        </div>
        <div class="modal_form_field bas" v-show="assetDetails.isServiceable">
          <label class="assets_label required">{{
            $t("text.assets.serviceDate")
          }}</label>
          <vue-ctk-date-time-picker
            id="serviceDate"
            v-model="assetDetails.serviceDate"
            :onlyDate="true"
            :autoClose="true"
            color="#370f70"
            format="YYYY-MM-DDTHH:mm:ss"
            formatted="DD/MM/YYYY"
            class="assets_date_picker"
            label="Select a date"
            position="top"
          />
        </div>
        <div class="modal_form_field bas" v-show="assetDetails.isRenewable">
          <label class="assets_label required">{{
            $t("text.assets.renewalDate")
          }}</label>
          <vue-ctk-date-time-picker
            id="RenewalDate"
            v-model="assetDetails.renewalDate"
            :onlyDate="true"
            :autoClose="true"
            color="#370f70"
            format="YYYY-MM-DDTHH:mm:ss"
            formatted="DD/MM/YYYY"
            class="assets_date_picker"
            label="Select a date"
            position="top"
          />
        </div>
        <div class="modal_form_field bas">
          <label class="assets_label">{{ $t("text.assets.expiryDate") }}</label>
          <vue-ctk-date-time-picker
            id="ExpiryDate"
            v-model="assetDetails.expirationDate"
            :onlyDate="true"
            :autoClose="true"
            color="#370f70"
            format="YYYY-MM-DDTHH:mm:ss"
            formatted="DD/MM/YYYY"
            class="assets_date_picker"
            label="Select a date"
            position="top"
          />
        </div>
        <button
          @click="editAsset($event)"
          class="assets_button bas"
          :disabled="isButtonDisabled ? true : null"
          :style="[
            isButtonDisabled
              ? { cursor: 'not-allowed' }
              : { cursor: 'pointer' },
          ]"
        >
          {{ $t("text.editAsset.save") }}
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="20px"
            class="ml-3 loader"
          />
        </button>
      </form>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 1080;
import configObject from "@/config";

export default {
  name: "editAsset",
  props: ["companyId", "branchId", "currentData"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
      isServicable: false,
      isRenewable: false,
      serviceDate: null,
      renewalDate: null,
      expiryDate: null,
      groupId: "selectGroup",
      groups: [],
      assetName: null,
      assetDescription: null,
      assetId: null,
      assetDetails: {},
      group: {},
      assetstatus: "",
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  mounted() {},
  methods: {
    getGroup() {
      this.group = this.groups.filter(
        (group) => group.id === this.assetDetails.assetGroupId
      )[0];
      this.assetstatus = this.group.groupType;
    },
    opened() {
      this.getGroups();
      this.getAsset();
    },
    closed() {
      this.assetName = "";
      this.assetDescription = "";
      this.assetId = "";
      this.groupId = "selectGroup";
      this.serviceDate = "";
      this.renewalDate = "";
      this.expiryDate = "";
      this.isServicable = false;
      this.isRenewable = false;
      this.documents = [];
      this.group = {};
    },
    toggleCheck() {
      this.isServicable = !this.isServicable;
    },
    toggleRenewalCheck() {
      this.isRenewable = !this.isRenewable;
    },
    closeModal() {
      this.$modal.hide("editAsset");
    },
    getGroups() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Assets/asset-groups?companyId=${this.companyId}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.groups = res.data;
        })
        .catch((error) => {});
    },
    getAsset() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Assets/${this.currentData.id}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.assetstatus = res.data.assetstatus;
          res.data.formattedStatus =
            res.data.assetstatus == 0
              ? "Okay"
              : res.data.assetstatus == 1
              ? "Service Due"
              : res.data.assetstatus == 2
              ? "Renewal Due"
              : res.data.assetstatus == 3
              ? "Expired"
              : res.data.assetstatus == 4
              ? "Service due and expired"
              : "Renewal due and expired";
          this.assetDetails = res.data;
        })
        .catch((error) => {});
    },
    editAsset(e) {
      e.preventDefault();
      if (!this.assetDetails.name) {
        this.$toast.open({
          message: this.$t("text.assets.assetLNameRequired"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.assetDetails.description) {
        this.$toast.open({
          message: this.$t("text.assets.assetDescRequired"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      let formData = {
        name: this.assetDetails.name,
        description: this.assetDetails.description,
        assetGroupId: this.assetDetails.assetGroupId,
        assetLicenseNo: this.assetDetails.assetLicenseNo,
        isServiceable: this.assetDetails.isServiceable,
        isRenewable: this.assetDetails.isRenewable,
        parentID: this.assetDetails.parentID,
        expirationDate: this.assetDetails.expirationDate,
        serviceDate: this.assetDetails.serviceDate,
        renewalDate: this.assetDetails.renewalDate,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .put(
          `${configObject.apiBaseUrl}/Assets/${this.currentData.id}`,
          this.assetDetails,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: this.$t("text.assets.successfullyUpdatedAsset"),
            type: "success",
            duration: 5000,
          });

          $(".loader").hide();
          this.isButtonDisabled = false;
          this.$eventHub.$emit("refreshBranchAssets");
          this.closeModal();
        })
        .catch(() => {
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
  },
};
</script>
